<script>
    //import { onDestroy } from 'svelte'
    import { alert, user } from '../store.js'
    import {ToastNotification} from "carbon-components-svelte";
  
    function tokenExpiry(msg) {
      if (msg.includes("token is expired by")) {
        return true
      } else {
        return false
      }
    }

    function clearUser() {
      $user = [];
    }
  </script>
<div>
  {#each $alert as item}
  {#if tokenExpiry(item)}
  <div use:clearUser></div>
  {/if}
  <ToastNotification
  hideCloseButton
  iconDescription="close alert"
  subtitle="{item}"
  timeout={8000}
  title="Notification"
  />
  {/each}
</div>



<!--   <style>
  div {
    position: fixed;
    cursor: pointer;
    margin-right: 1.5rem;
    margin-left: 1.5rem;
    margin-top: 1rem;
    right: 0;
    display: flex;
    align-items: center;
    border-radius: 0.2rem;
    background-color: #565656;
    color: #fff;
    font-size: 0.875rem;
    font-weight: 700;
    padding: 0.5rem 1.4rem;
    font-size: 1.5rem;
    z-index: 100;
    opacity: 95%;
  }
  div p {
    color: #fff;
  }
  div svg {
    height: 1.6rem;
    fill: currentColor;
    width: 1.4rem;
    margin-right: 0.5rem;
  }
  </style> -->
  